{
  "GenericModal_PromptMessage": "Êtes-vous sûr de vouloir fermer cette fenêtre ? Toutes les configurations modifiées seront perdues à la fermeture.",
  "GenericModal_PromptConfirm": "Oui",
  "GenericModal_PromptCancel": "Annuler",
  "NAME": "GenericModal"
}